import { render, staticRenderFns } from "./FeedbackRequestsOverview.vue?vue&type=template&id=09979a8a&"
import script from "./FeedbackRequestsOverview.vue?vue&type=script&lang=js&"
export * from "./FeedbackRequestsOverview.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackRequestsOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports